export const extractFileNameFromPath = (path: string | null | undefined) => path?.split("/").pop()?.split(".")[0];
